<template>
    <div>
        <div>
            {{title}}
        </div>
        <div>
            {{sub_title}}
        </div>
    </div>
  </template>
  <script>
  export default {
    props: ['title', 'sub_title'],

  }
  </script>
  